import React from 'react';

const BuildingIcon = ({ color = '#424242', width = 20, height = 21, ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <path d="M18.3346 18.832L1.66797 18.832" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M17.5016 18.8346V5.5013C17.5016 3.92995 17.5016 3.14428 17.0134 2.65612C16.5253 2.16797 15.7396 2.16797 14.1683 2.16797H12.5016C10.9302 2.16797 10.1446 2.16797 9.65641 2.65612C9.26346 3.04908 9.18682 3.63482 9.17188 4.66797"
        stroke={color}
        strokeWidth="1.25"
      />
      <path
        d="M12.5 18.8346V8.0013C12.5 6.42995 12.5 5.64428 12.0118 5.15612C11.5237 4.66797 10.738 4.66797 9.16667 4.66797H5.83333C4.26198 4.66797 3.47631 4.66797 2.98816 5.15612C2.5 5.64428 2.5 6.42995 2.5 8.0013V18.8346"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M7.5 18.832V16.332" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M5 7.16797H10" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M5 9.66797H10" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M5 12.168H10" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};

export default React.forwardRef(BuildingIcon);
